export * as maintenance from './enumModules/maintenance';
export * as feedback from './enumModules/feedback';

export const receiveStatus = [
  { label: '待领取', value: -1, color: '#F17226' },
  { label: '待发放', value: 0, color: '#0450B4' },
  { label: '已发放', value: 1, color: '#999999' },
];

export const pointsReceiveStatus = [
  { label: '待领取', value: -1, color: '#F17226' },
  { label: '待发放', value: 0, color: '#0450B4' },
  { label: '已领取', value: 1, color: '#999999' },
];
